var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageAccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 12 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5670_7707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00903 3.25C3.58301 3.25 1.59743 5.23567 1.59743 7.66169V8.26424H3.36417V7.66169C3.36417 6.19048 4.53786 5.01679 6.00903 5.01679C7.48019 5.01679 8.65388 6.19048 8.65388 7.66169V10.0788C7.87559 9.61371 6.96732 9.34572 5.99902 9.34572C3.13644 9.34572 0.796875 11.6853 0.796875 14.5479C0.796875 17.4104 3.13644 19.75 5.99902 19.75C8.86159 19.75 11.2012 17.4105 11.2012 14.5479C11.2012 13.5471 10.9149 12.6105 10.4207 11.8152V7.66169C10.4207 5.23567 8.43504 3.25 6.00903 3.25ZM5.99902 11.1125C7.90674 11.1125 9.43437 12.6401 9.43437 14.5479C9.43437 16.4556 7.90674 17.9832 5.99902 17.9832C4.09129 17.9832 2.56366 16.4556 2.56366 14.5479C2.56366 12.6401 4.09129 11.1125 5.99902 11.1125ZM6.01599 13.106C5.21097 13.106 4.5584 13.7585 4.5584 14.5635C4.5584 15.3686 5.21097 16.0211 6.01599 16.0211C6.82101 16.0211 7.47357 15.3686 7.47357 14.5635C7.47357 13.7585 6.82096 13.106 6.01599 13.106Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5670_7707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 22,
    fill: "white",
    transform: "translate(0.499023 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccessIcon);
export default __webpack_public_path__ + "static/media/manage-access-icon.d54ce045d3d151d4f6b633840d94e8ef.svg";
export { ForwardRef as ReactComponent };